const srednica = { t: 'Średnica', name: 'srednica', hint: { url: '/part_diameter' }}
export default srednica